<template>
    <div class="index notranslate">
        <v-header></v-header>

        <!-- cart content -->
        <mu-container class="content" style="padding-left:0px;padding-right:0px;overflow-y:auto;padding-bottom:60px;" v-show="!showOrderTip">
            <div class="cart-box" v-for="(val, key, index) in cartShowData" :key="index">
                <mu-list>
                    <mu-list-item style="height:36px;">
                        <mu-list-item-content>
                            <mu-list-item-title class="table-info-list-title">{{key.replace(/\"/g,"")}}</mu-list-item-title>
                        </mu-list-item-content>
                    </mu-list-item>
                    <mu-divider></mu-divider>
                    <mu-list-item style="height:50px;margin:10px auto;" v-for="item,index in val" :key="index">
                        <mu-flex class="flex-wrapper">
                            <img :src="getImgUrl(item.foodImage,200)" style="border-radius:0;width:60px;height:40px;">
                            <div style="margin-left: 10px;height:40px;width:100%;float:left;">
                                <div style="float:left;">
                                    <div style="font-size:12px;height:12px;line-height:12px;width:100%;">
                                        {{item.foodName}}
                                    </div>
                                    <div style="font-size:12px;height:12px;line-height:12px;width:100%;" v-if="item.decideName!=null && item.decideName!=''">
                                        {{item.decideName}}
                                    </div>
                                    <div>
                                        <span class="now">{{Number(item.price * item.foodDiscount).toFixed(0)}} {{seller.unit}}</span><span v-show="item.foodDiscount!=1" class="old">{{Number(item.price)}}  {{seller.unit}}</span>
                                    </div>
                                </div>
                                <div class="cart-opration notranslate">
                                    <mu-button class="cart-opration-btn" @click="cartOpration(item,'reduce')" style="padding:0;" >
                                        <mu-icon value="remove" style="font-weight: 600;font-size:14px;"></mu-icon>
                                    </mu-button>
                                    <mu-button class="cart-opration-quantity" style="padding:0;">
                                        <div style="font-size:12px;font-weight: 500;">{{item.quantity}}</div>
                                    </mu-button>
                                    <mu-button class="cart-opration-btn" @click="cartOpration(item,'add')"  :class="(payClass===true||item.unAdd)?'form-onlyread':''" style="padding:0;">
                                        <mu-icon value="add" style="font-weight: 600;font-size:14px;"></mu-icon>
                                    </mu-button>
                                </div>
                            </div>
                        </mu-flex>
                    </mu-list-item>
                </mu-list>
            </div>
            <mu-list>
                <mu-list-item style="height:40px;float:right;margin-bottom:10px;">
                    <mu-list-item-content style="font-size:18px;font-weight:600;">
                        {{$t('orderList.total')}}:<span style="color:#f01414;font-weight:600;"> {{allAmount}} {{seller.unit}}</span>
                    </mu-list-item-content>
                </mu-list-item>
            </mu-list>

            

            <mu-list style="padding-bottom:0px;background-color:#e0e0e0">
                <!--<mu-expansion-panel :expand="true">-->
                    <!--<div slot="header">Remark</div>-->
                    <mu-text-field multi-line :rows="3" label-float  :label="$t('orderList.sendKitchen')" :rows-max="6" v-model="tableOrderInfo.specielle" style="margin-bottom: 0px;background-color: #fdf6ec; font-size: 16px;width:100%;"></mu-text-field>
                <!--</mu-expansion-panel>-->
                <diV v-if="tasteList.length>0"  >
                    <mu-button  style="margin: 5px;"  :key="index" @click="clickTaste(item)" v-for="(item,index) in tasteList" color="rgb(218, 91, 58)">   {{item.tasteName}} </mu-button>
                </diV>
            </mu-list>
     

            <div style="right:0;position:absolute;bottom:50px;" v-if="unPayTip!=''">
                <mu-chip class="demo-chip" key="1" color="error" @delete="removeTip(1)" delete>{{unPayTip}}</mu-chip>
            </div>

            <div class="oprations" v-show="!showOrderTip">
                <div class="oprations-btn">
                    <div class="oprations-back" @click="jumpBack">{{$t('common.back')}}</div>
                </div>
                <div class="oprations-btn">
                    <div class="oprations-next enough" @click="order">{{$t('common.submit')}}</div>
                </div>
            </div>
           

            <div style="background-color:#000;position:absolute;top:0;opacity:0.5;height:100%;width:100%;z-index:99999;color:#fff;text-align:center;" v-if="isLoading">
                <div v-loading="true" style="vertical-align:central;margin-top:60%;">
                </div>
                {{$t('orderList.orderSubmitted')}}
            </div>
        </mu-container>

        <div style="width: 100%; background: #fff; padding: 20px;text-align:center;padding-top:60px;" v-show="showOrderTip">
            <mu-flex class="flex-wrapper" justify-content="center">
                <div style="font-size:16px;font-weight:600;color:#DA5B3A;">{{$t('orderList.submitCart')}}</div>
            </mu-flex>
            <mu-flex class="flex-wrapper" justify-content="center">
                <div style="width: 100%; text-align: center; margin-top: 30px;"><mu-button color="success" class="notranslate" @click="jumpBack" style="text-transform:unset;">{{$t('orderList.return')}}</mu-button></div>
            </mu-flex>
        </div>

        <mu-dialog :title="$t('orderList.orderChangeTip')" width="360" :open.sync="openOrderChange" :overlay-close="false" :esc-press-close="false">
            {{$t('common.orderstatechange')}}
            <mu-button slot="actions" flat color="primary" @click="jumpOrderChange" style="color: #da5b3a;"> {{$t('common.sure')}}</mu-button>
        </mu-dialog>
    </div>
</template>
<script>
    import header from '../components/TakeawayHeader';
    export default {
        name: 'TakwawayCartList',
        data() {
            return {
                docked: false,
                open: false,
                tableOrderInfo: {},
                refreshDisbale: false,
                cartList: [],
                cartShowData: {},
                openFullscreen: false,
                allAmount: 0,
                showOrderTip: false,
                packageType: 0,
                isSeft: 0,
                seller: {},
                isSeftPay: 0,
                current: -1,
                isLoading: false,
                tasteList: [],
                disFlag: true,
                configsData: {},
                orderData: {},
                orderList: [],
                unPayTip: '',
                openOrderChange: false,
                timer: null
            }
        },
        computed: {
            payClass() {
                this.unPayTip = '';
                return false;
            }
        },
        mounted() {
            this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
            this.isSeft = this.$route.query.isSeft;
            this.packageType = this.$route.query.packageType;
            this.isSeftPay = this.$route.query.isSeftPay;
            this.getCartList();
            this.getFoodTasteList();
            //this.getConfigs();
        },
        methods: {
            jumpOrderChange() {
                this.openOrderChange = false;
                this.$router.push({
                    path: '/result'
                })
            },
            removeTip(index) {
                this.unPayTip = "";
            },
            openDrawer() {
                this.open = !this.open;
                this.docked = false;
            },
            clickTaste(item) {
                if (this.tableOrderInfo.specielle == null) {
                    this.tableOrderInfo.specielle = "";
                }
                this.tableOrderInfo.specielle = this.tableOrderInfo.specielle + item.tasteName;
            },
            getConfigs() {
                this.$get('QRCodeBasicInfo/GetConfigs', { restaurantId: this.tableOrderInfo.restaurantId})
                    .then(response => {
                        if(response.code==200){
                            response.data.forEach((item) => {
                                this.configsData[item.configKey]= item.configValue;
			                })
                        }
                    });
            },
            getFoodTasteList() {
                this.$get('QRCodeOrder/GetFoodTasteList', {restaurantId: this.tableOrderInfo.restaurantId})
                    .then(response => {
                        if (response.code==200) {
                            this.tasteList = response.data;
                        } else {
                            this.$alert('The web cannot be accessed, please contact the manager!', 'Alert');
                        }
                    });
            },
            getCartList() {
                let param = {
                    RestaurantId: this.tableOrderInfo.restaurantId,
                    TableName:this.tableOrderInfo.tableName,
                    Telephone: this.tableOrderInfo.telephone
                };
                this.allAmount=0;
                this.$get('QRCodeOrder/GetCartListByPhone', param)
                    .then(response => {
                        if (response.code==200) {
                            this.cartList = response.data;
                            this.current = -1;
                            if (this.cartList.length == 0) {
                                this.cartShowData = [];
                            }
                            else {
                                var total = 0;
                                this.showOrderTip = false;
                                this.cartList.forEach(function (item) {
                                    total += Math.round(item.quantity * item.price);
                                });
                                this.allAmount = total;
                                this.cartShowData = this.groupBy(this.cartList, (cart) => {
                                    return cart.foodTypeName
                                });
                            }
                        } else {
                            this.showOrderTip = true;
                        }
                    });
            },
            groupBy(list, fn) {
                const groups = {};
                list.forEach(function (o) {
                    const group = JSON.stringify(fn(o));
                    groups[group] = groups[group] || [];
                    groups[group].push(o);
                });
                return groups;
            },
            getImgUrl(image,w=0) {
                if (image == undefined || image == 'undefined' || image == null|| image == '') {
                    return '../static/img/default.png';
                }
                if(w==0){
                    return this.global.baseUrl + "uploads/" + image
                }
                return  this.global.baseUrl+"api/images/"+w+"/"+ image
            },
            refresh() {
                this.getCartList();
                this.$toast.success('Successfully refresh!');
            },
            jumpBack() {
                this.$router.go(-1);
            },
            jumpOrderLink() {
                this.open = false;
                this.docked = true;
                this.$router.push({
                    path: '/orderList', query: {
                        packageType: this.packageType,
                        isSeft: this.isSeft,
                        isBackMain: false,
                    }
                })
            },
            cartOpration(item, oprationType) {
                switch (oprationType) {
                    case 'add':
                        this.addToCart(item);
                        break;
                    case 'reduce':
                        if (item.quantity <= 0) {
                            return;
                        }
                        this.reduceCart(item);
                        break;
                }
            },
            addToCart(food) {
                let param = {
                  
                        RelatedId:food.relatedId,
                        RestaurantId: this.tableOrderInfo.restaurantId,
                        TableName: this.tableOrderInfo.tableName,
                }
                this.$post('QRCodeOrder/UpdateCartList', param)
                    .then(response => {
                        if (response.code == 200) {
                            this.getCartList();
                        } else {
                            this.$alert('The site cannot be accessed, please contact the manager!', 'Alert');
                        }
                    });
            },
            reduceCart(item) {
                if (item.quantity <= 1) {
                    this.$confirm(this.$t("common.deleteConfirm"), this.$t("common.confirm"), {
                        type: 'warning',
                        okLabel: this.$t("common.ok"),
                        cancelLabel: this.$t("common.cancel")
                    }).then(({ result }) => {
                        if (result) {
                            let param = {
                                RestaurantId: this.tableOrderInfo.restaurantId,
                                TableName:this.tableOrderInfo.tableName,
                                FoodId: item.foodId,
                                FoodName: item.foodName,
                                ActDiscount: item.actDiscount,
                                Price: item.price,
                                FoodImage: item.foodImage,
                                FoodTypeName: item.foodTypeName,
                                AllowDiscounts: item.allowDiscounts,
                                Quantity: 1,
                                CreateUser: this.tableOrderInfo.name,
                                CreatePhone: this.tableOrderInfo.telephone,
                                IsSeft: 0,
                                Reamrk: item.reamrk,
                            };
                            this.$post('QRCodeOrder/ReduceCart', param)
                                .then(response => {
                                    if (response.code == 200) {
                                        this.getCartList();
                                    } else {
                                        this.$alert('The site cannot be accessed, please contact the manager!', 'Alert');
                                    }
                                });
                        } else {

                        }
                    });
                }
                else {
                    let param = {
                        RestaurantId: this.tableOrderInfo.restaurantId,
                        TableName:this.tableOrderInfo.tableName,
                        FoodId: item.foodId,
                        FoodName: item.foodName,
                        ActDiscount: item.actDiscount,
                        Price: item.price,
                        FoodImage: item.foodImage,
                        FoodTypeName: item.foodTypeName,
                        AllowDiscounts: item.allowDiscounts,
                        Quantity: 1,
                        CreateUser: this.tableOrderInfo.name,
                        CreatePhone: this.tableOrderInfo.telephone,
                        IsSeft: 0,
                        Reamrk: item.reamrk,
                    };
                    this.$post('QRCodeOrder/ReduceCart', param)
                        .then(response => {
                            if (response.code == 200) {
                                this.getCartList();
                            } else {
                                this.$alert('The site cannot be accessed, please contact the manager!', 'Alert');
                            }
                        });
                }
            },
            openFullscreenDialog() {
                this.openFullscreen = true;
                this.open = false;
                this.docked = true;
            },
            closeFullscreenDialog() {
                this.openFullscreen = false;
            },
            dataLen(d) {
                if (d < 10) {
                    return "0" + d;
                }
                return d;
            },
            order() {
               
                this.setItem('sessionStorage', 'tableOrderInfo', this.tableOrderInfo,72000000);
                this.disFlag = false;
                this.$router.push({ path: '/takwawayInfo', query: { } });
            },
            getPath() {
                if (this.$route.path == '/takwawayCartList') {
                    this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
                    this.getCartList();
                }
            },
   
        },
        watch: {
            '$route': 'getPath'
        },     
        components: {
            'v-header': header
        }
    }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
    .nav-title {
        text-align: center;
    }

    .mu-list {
        padding: 0px;
    }

    .mu-raised-button .mu-button-wrapper {
        padding: 0 12px;
    }

    .mu-button {
        text-transform: unset;
    }

        .mu-button .mu-icon-left {
            margin-right: 3px;
        }

    .material-icons {
        font-size: 12px;
    }

    .content {
        /*  background-image: url(../assets/image/background.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;*/
        width: 100%;
        height: 100%;
        position: absolute;
    }

    .cart-box {
        position: relative;
        margin: auto;
        background-color: #fff;
        background-size: cover;
        overflow-y: unset;
    }

    .table-info-keywords {
        color: #e53935;
        font-size: 18px;
        font-weight: 600;
        margin-left: 10px;
    }

    .table-info-list-title {
        text-align: center;
        font-size: 14px;
        color: #4fc3f7;
    }

    .cart-opration {
        float: right;
        right: 10px;
        position: absolute;
    }

    .cart-opration-btn {
        width: 36px;
        height: 36px;
        min-width: unset;
        font-size: 16px;
        color: #e53935;
        padding: 0px;
    }

    .cart-opration-quantity {
        width: 36px;
        height: 36px;
        min-width: unset;
        top: -2px;
    }

    .btn-refresh {
        position: fixed;
        right: 10px;
        background-color: #757575 !important;
        z-index: 10;
    }

    .btn-menu {
        position: fixed;
        bottom: 10px;
        left: 10px;
        background-color: #757575 !important;
    }

    .btn-continue {
        position: fixed;
        bottom: 10px;
        background-color: #757575 !important;
        left: 41%;
    }

    .btn-refresh {
        position: fixed;
        bottom: 10px;
        left: 10px
    }

    .btn-order {
        position: fixed;
        bottom: 10px;
        right: 10px
    }

    .now {
        font-size: 12px;
        color: #f01414;
        font-weight: 700;
        line-height: 24px;
        margin-right: 8px;
    }

    .old {
        font-size: 12px;
        text-decoration: line-through;
        color: #93999f;
        font-weight: 700;
        line-height: 24px;
    }

    .ower {
        position: relative;
        z-index: 9;
        padding: 10px;
        background-color: #fff;
    }

    .badge-num {
        float: left;
        width: 60px;
        height: 32px;
        margin-right: 5px;
        margin-bottom: 5px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 0 6px;
        line-height: 1.5;
        font-size: 14px;
        font-style: normal;
        background-color: #bdbdbd;
        color: #fff;
        border-radius: 3px;
        overflow: hidden;
    }

    .select {
        background-color: rgb(218, 91, 58);
    }

    .oprations {
        position: fixed;
        bottom: 0;
        right:0;
    }

        .oprations .oprations-btn {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 105px;
            flex: 0 0 105px;
            width: 105px;
            float: left;
        }
            .oprations .oprations-btn .oprations-back {
                height: 48px;
                line-height: 48px;
                font-size: 12px;
                font-weight: 700;
                text-align: center;
                background-color: #bdbdbd;
                color: #fff;
                float: right;
                width:100%;
            }

            .oprations .oprations-btn .oprations-next {
                height: 48px;
                line-height: 48px;
                font-size: 12px;
                font-weight: 700;
                text-align: center;
                float: right;
                width: 100%;
            }

        .oprations .oprations-btn .oprations-next.not-enough {
            background: #2b333b;
        }

        .oprations .oprations-btn .oprations-next.enough {
            background: #00b43c;
            color: #fff;
        }

    .form-onlyread {
        pointer-events: none;
        background: #e0e0e0;
    }
</style>



// WEBPACK FOOTER //
// src/components/TakwawayCartList.vue